import space2CheckService from '../../api/space2check'
import errorhandler from '@/utils/errorhandler.js'

export default {
  namespaced: true,
  actions: {
    async getSpace2CheckList({ dispatch }) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        const response = await space2CheckService.getSpaces2Check()
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async getSpace2Check({ dispatch }, space2checkId) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        const response = await space2CheckService.getSpace2Check(space2checkId)
        return response.data
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async createDevice({ dispatch }, device) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await space2CheckService.createDevice(device)
        dispatch('Global/showMessage', 'createSpace2CheckSuccessfully', { root: true })
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async editDevice({ dispatch }, device) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await space2CheckService.editDevice(device)
        dispatch('Global/showMessage', 'editSpace2CheckSuccessfully', { root: true })
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    },
    async deleteDevice({ dispatch }, device) {
      dispatch('Global/showLoading', null, { root: true })
      try {
        await space2CheckService.deleteDevice(device)
        dispatch('Global/showMessage', 'deleteDeviceSuccessfully', { root: true })
      } catch (error) {
        errorhandler.handleError(error)
      } finally {
        dispatch('Global/hideLoading', null, { root: true })
      }
    }
  }
}
